<template>
  <div class="content-card sim-type-selection">
    <div class="sim-data--header"><slot name="txtHeadline">DATA</slot></div>
    <b-form id="customer-data-form" :novalidate="true">
      <LabeledRadioInput name="simType"
                         class="simType"
                         :model.sync="simType_"
                         :label="getSlotText('lblType')"
                         :invalid.sync="invalidSim"
                         first-radio-value="SIM_CARD"
                         second-radio-value="E_SIM"
                         first-radio-id="sim-card"
                         second-radio-id="e-sim"
      >
        <template v-slot:afterLabel><button type="button" @click="trackAndShowSimTypeInfoModal()" class="icon-only"><img src="files/flash/images/svg-icons/info-icon.svg" :alt="getSlotText('accessibilityInfoIconAlt')"></button></template>
        <template v-for="slot in possibleChildSlotsFor('SimType')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </LabeledRadioInput>
      <div class="info-device-box">
        <a href="javascript:;" class="device-check-link text-nowrap" @click.prevent="trackAndShowESimCheckInfoModal()"><slot name="txtESimDeviceCheckLink"></slot></a>
      </div>
      <SimonModal
        :is-visible="showSimTypeInfoModal"
        @hide="showSimTypeInfoModal = false"
        id="sim-type-info-modal"
        size="large"
      >
        <template v-slot:modalTitle>
          <h3><slot name="titleSimTypeInfoModal"></slot></h3>
        </template>
        <b-tabs card pills align="center">
          <b-tab :title="getSlotText('tabSimTypeInfoModalSim')" :active="!isESimSelected">
            <b-card-text><slot name="txtSimTypeInfoModalSim"></slot></b-card-text>
          </b-tab>
          <b-tab :title="getSlotText('tabSimTypeInfoModalESim')" :active="isESimSelected">
            <b-card-text><slot name="txtSimTypeInfoModalESim"></slot></b-card-text>
          </b-tab>
        </b-tabs>
      </SimonModal>
      <SimonModal
        :is-visible="showESimCheckInfoModal"
        @hide="showESimCheckInfoModal = false"
        id="esim-check-info-modal"
        size="large"
        custom-modal-class="esim-check-info-modal"
      >
        <template v-slot:modalTitle><h3><slot name="txtTitleModalDeviceCheck"></slot></h3></template>
        <b-form-group class="custom-input-select">
          <b-form
            :id="'form' + _uid"
            :novalidate="true"
            class="device-check-modal-form"
            ref="form">
            <ESimDevicecheck>
              <template v-for="slot in possibleChildSlotsFor('DeviceCheck')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </ESimDevicecheck>
          </b-form>
        </b-form-group>
      </SimonModal>
    </b-form>
  </div>
</template>
<script>

import { BForm } from 'bootstrap-vue'
import ESimDevicecheck from '@/components/checkout/simData/ESimDevicecheck.vue'
import syncProperty from '@/mixins/syncProperty'
import SimonModal from '@/components/modal/SimonModal.vue'
import LabeledRadioInput from '../../forms/LabeledRadioInput.vue'

export default {
  name: 'SimSelection',
  data () {
    return {
      showSimTypeInfoModal: false,
      showESimCheckInfoModal: false,
      invalidSim: true
    }
  },
  mixins: [
    syncProperty('simType', 'simType_')
  ],
  components: { BForm, LabeledRadioInput, SimonModal, ESimDevicecheck },
  computed: {
    isESimSelected () {
      return this.simType_ === 'E_SIM'
    }
  },
  methods: {
    trackAndShowSimTypeInfoModal () {
      this.showSimTypeInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'sim type info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    trackAndShowESimCheckInfoModal () {
      this.showESimCheckInfoModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'device check info modal',
        information_ui_type: 'overlay',
        information_trigger: 'icon'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    }
  },
  props: {
  }
}
</script>
